<template>
  <div class="menu-mobile-header">
    <span class="menu-mobile-header__back" @click="$emit('stepBack')">
      <svg><use xlink:href="#svg-arrow-left"></use></svg>
      <slot />
    </span>
    <span class="menu-mobile-header__close" @click="$emit('close')">
      <svg><use xlink:href="#svg-close"></use></svg>
    </span>
  </div>
</template>

<script>
export default {
  name: 'MenuMobileHeader',
  props: ['result'],
};
</script>

<style lang="scss" scoped>
.menu-mobile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 48px;
  padding: 0 16px;
  background-color: var(--background-black);
  color: #fff;
  &__close {
    svg {
      width: 24px;
      height: 24px;
      margin-left: 12px;
      fill: currentColor;
    }
  }
  &__back {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
    line-height: 125%; /* 20px */
    text-transform: uppercase;
    svg {
      width: 24px;
      height: 24px;
      margin-right: 12px;
      fill: currentColor;
    }
  }
}
</style>
